<template>
  <div class="menu-image-generate">
    <a-card :bordered="false">
      <template #title>
        <div class="page-header">
          <a-button type="text" class="back-button" @click="goBack">
            <template #icon><ArrowLeftOutlined /></template>
          </a-button>
          <span class="page-title">菜单图生成</span>
        </div>
      </template>
    </a-card>
  </div>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import { ArrowLeftOutlined } from '@ant-design/icons-vue';

  const router = useRouter();

  const goBack = () => {
    router.back();
  };
</script>

<style scoped lang="less">
  .menu-image-generate {
    min-height: 100vh;
    background: #f0f2f5;

    .page-header {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .back-button {
      padding: 0;
    }

    .page-title {
      font-size: 18px;
      font-weight: 600;
    }
  }
</style>
